// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"7286c11b","161":"46bffa0d","240":"7286c11b","294":"8209cc75","355":"9368c9ad","798":"fab21c00","862":"7286c11b","918":"7286c11b"}[chunkId] + ".chunk.css";
};